import classnames from "classnames";

import { useSelector } from "seneca-common/utils/hooks/selectors";

import { isLocalizeLoaded } from "features/common/localisation/utils";
import { getSplashScreenBackgroundColor } from "features/dark-mode/utils";
import { useIsPlurallApp } from "features/plurall";
import { getRegion } from "features/regions/selectors";

import "./SplashScreen.scss";

type Props = {
  className?: string;
};

export default function SplashScreen({ className }: Props) {
  const isPlurallApp = useIsPlurallApp();
  const region = useSelector(getRegion);
  const showGoStudentLogo = (region && region !== "GB") || isLocalizeLoaded();

  const backgroundColor = getSplashScreenBackgroundColor();

  return (
    <div
      className={classnames("SplashScreen__wrapper", className)}
      style={{ backgroundColor: backgroundColor }}
    >
      <div
        className={`SplashScreen__logo ${
          isPlurallApp
            ? "PlurallLogo__logo"
            : showGoStudentLogo
            ? "SenecaByGoStudentLogo__logo"
            : "LightBlueLogo__logo"
        }`}
      />
    </div>
  );
}
